import { MutationFunction, QueryFunction } from '@tanstack/react-query';
import {
  CostCenterDto,
  CreateCostCenterDto,
  UpdateCostCenterDto,
} from 'desk-common';
import api from './api';
import { CostCentersParams } from '../interfaces/filterParams.interface';

export const getCostCentersList: QueryFunction<
  CostCenterDto[],
  readonly [string, CostCentersParams]
> = async ({ queryKey }) => {
  const [, params] = queryKey;

  const hasFilters = params && Object.keys(params).length > 0;

  const response = await api.get('/cost-centers', {
    params: hasFilters ? { filters: JSON.stringify(params) } : undefined,
  });

  return response.data;
};

export const createCostCenter: MutationFunction<
  { providerId: string },
  CreateCostCenterDto
> = async ({ ...data }) => {
  const response = await api.post('/cost-centers', data);
  return response.data;
};

export const updateCostCenter: MutationFunction<
  void,
  UpdateCostCenterDto & { id: number }
> = async ({ id, ...data }) => {
  const response = await api.put(`/cost-centers/${id}`, data);
  return response.data;
};

export const disableCostCenter: MutationFunction<
  void,
  { id: number }
> = async ({ id }) => {
  const response = await api.put(`/cost-centers/disable/${id}`);
  return response.data;
};
